export default "__VITE_ASSET__6p80_DCN__"